import { uuidV7 } from '@repletoryreach/sdk-utils/crypto';

export function generateIdempotencyKey(): string {
  return uuidV7();
}
